import { useState } from 'react';

export default function useContactModal() {
    const [isVisible, setIsVisible] = useState(false);

    function toggle() {
        setIsVisible((prev) => !prev);
    }

    function close() {
        setIsVisible(false);
    }

    return { isVisible, toggle, close };
}
